export default __webpack_public_path__ + "static/media/IMG-20210701-WA0061.ac8b0e50.jpg";